
import { GlobalController } from 'src/shared/global/GlobalController'
import Client from './Client'
import ClientPage from './ClientPage'
import ClientRegisterPage from './ClientRegisterPage'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'client',
    component: Client,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: ':link',
    name: 'clientPage',
    component: ClientPage,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: ':link',
    name: 'clientRegisterPage',
    component: Client,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: 'clientRegister',
    name: 'clientRegister',
    component: ClientRegisterPage,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
